// extracted by mini-css-extract-plugin
module.exports = {"footerLinks":"Footer_footerLinks__3I_Nj","footerBottom":"Footer_footerBottom__VxQ5y","divider":"Footer_divider__oPleq","copyright":"Footer_copyright__fV38_"};